import { render, staticRenderFns } from "./TermOfUseScreen.vue?vue&type=template&id=22be0329&scoped=true&"
import script from "./TermOfUseScreen.vue?vue&type=script&lang=js&"
export * from "./TermOfUseScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22be0329",
  null
  
)

export default component.exports